module.exports = __webpack_public_path__ + "img/sidenav-item-price-settings.0d464cc6.svg";